import { Formik, Form } from "formik";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ReCAPTCHA from "react-google-recaptcha";
import { CircularProgress } from "@material-ui/core";
import { initialValues, validateForm } from "../config/configForm";
import { useRef } from "react";
import { useStyles } from "../styles/configTheme";

const FormBalance = ({ handleSubmit, error, setError }) => {
  const classes = useStyles();

  const keyCaptcha = process.env.REACT_APP_RECAPTCHA_API_KEY;

  const captcha = useRef(null);

  if (error) {
    captcha.current.reset();
  }

  return (
    <div>
      <h3 className="text-center fw-bold">Ingrese sus datos</h3>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validateForm}
      >
        {(formik) => (
          <Form className="d-flex flex-column justify-content-center">
            <FormControl className={classes.formControl}>
              <InputLabel id="nationality">Identificación</InputLabel>
              <Select
                labelId="nationality"
                id="Nationality"
                name="Nationality"
                value={formik.values.Nationality}
                onChange={formik.handleChange}
                error={
                  formik.touched.Nationality &&
                  Boolean(formik.errors.Nationality)
                }
              >
                <MenuItem value="V">V</MenuItem>
                <MenuItem value="E">E</MenuItem>
                <MenuItem value="P">P</MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                label="Número de Identificación"
                id="Identification"
                name="Identification"
                value={formik.values.Identification}
                onChange={formik.handleChange}
                error={
                  formik.touched.Identification &&
                  Boolean(formik.errors.Identification)
                }
                helperText={
                  formik.touched.Identification && formik.errors.Identification
                }
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                label="Número de Tarjeta"
                id="CardNumber"
                name="CardNumber"
                value={formik.values.CardNumber}
                error={
                  formik.touched.CardNumber && Boolean(formik.errors.CardNumber)
                }
                helperText={
                  formik.touched.CardNumber && formik.errors.CardNumber
                }
                onChange={formik.handleChange}
              />
            </FormControl>
            <div className="d-flex flex-column justify-content-center align-items-center my-3">
              <ReCAPTCHA
                ref={captcha}
                sitekey={keyCaptcha}
                onChange={(token) => formik.setFieldValue("recaptcha", token)}
                hl="es"
              />
              {formik.errors.recaptcha && formik.touched.recaptcha && (
                <p className="recaptcha-error my-2">
                  {formik.errors.recaptcha}
                </p>
              )}
            </div>

            {formik.isSubmitting ? (
              <div className="d-flex justify-content-center  my-2">
                <CircularProgress />
              </div>
            ) : (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={`${classes.customButtom} mb-3`}
              >
                Consultar Saldo
              </Button>
            )}
            {error && (
              <Button
                variant="contained"
                color="secondary"
                className={classes.customButtom}
                onClick={() => {
                  formik.resetForm();
                  setError("");
                }}
              >
                Limpiar Campos
              </Button>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormBalance;
